import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { endOfMonth, startOfMonth } from "date-fns";

export const IndexHooks = ({ options, handleSubmitModalFilter, filterData }) => {
	const parameterDefault = options?.parametersFilter?.[0];
	const value = parameterDefault?.value;
	const label = parameterDefault?.label;

	const parameterDefaultDate = options?.parametersDate?.[0];
	const valueDate = parameterDefaultDate?.value;
	const labelDate = parameterDefaultDate?.label;

	const hasParam = options.hasParam !== undefined ? options.hasParam : true;

	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		setValue,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			dtIni: startOfMonth(new Date()), // Define a data atual como valor padrão
			dtFim: endOfMonth(new Date()), // Define a data atual comnew Date(),
			param: { value, label },
			paramDate: { value: valueDate, label: labelDate },
			salesType: "",
			clientType: "",
			situacaoCompra: "S",
			paramValue: "",
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		const showTime = options.showTime;
		const hasActive = options.hasActive;

		const filterListFormated = {};

		Object.entries(data).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== "") {
				if (key === "param") {
					if (hasParam) {
						filterListFormated["param"] = {
							label: "Parametro",
							value: value.label,
						};
					}
				} else if (key === "paramDate") {
					filterListFormated["paramDate"] = {
						label: "Parametro",
						value: value.label,
					};
				} else if (key === "paramValue") {
					filterListFormated["paramValue"] = {
						label: "Valor:",
						value: value,
					};
				} else if (key === "clientType") {
					filterListFormated["clientType"] = {
						label: "Tipo de Cliente",
						value: value,
					};
				} else if (key === "salesType") {
					filterListFormated["salesType"] = {
						label: "Tipo de Venda",
						value: value,
					};
				} else if (key === "situacaoCompra") {
					filterListFormated["situacaoCompra"] = {
						label: "Situação",
						value: value === "S" ? "JÁ COMPROU" : value === "N" ? "NUNCA COMPROU" : "TODOS",
					};
				} else if (key === "active") {
					if (hasActive) {
						filterListFormated["active"] = {
							label: "Ativo", // Adiciona o label
							value: value ? "SIM" : "NAO", // Valor formatado
						};
					}
				} else if (value instanceof Date) {
					if (showTime) {
						filterListFormated[key] = {
							label: key === "dtIni" ? "Data Inicial" : key === "dtFim" ? "Data Final" : "Data", // A chave pode ser o label, ou você pode customizar isso
							value: value.toLocaleString("pt-BR"), // Converte Date para formato PT-BR com data e hora
						};
					}
				} else {
					filterListFormated[key] = {
						label: key, // A chave pode ser o label, ou você pode customizar isso
						value: value,
					};
				}
			}
		});

		await handleSubmitModalFilter(filterListFormated, data);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
		setValue,
		hasParam,
	};
};
